import { AttributeValueResolverService } from './attribute-value.service';
import { ArticleTypeAttribute } from './../../article-types/article-type.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attributeValue'
})
export class AttributeValuePipe implements PipeTransform {

  private DECIMAL_SCALE = 3;

  constructor(private attributeValueResolverService: AttributeValueResolverService) {
  }

  transform(value: string, articleTypeAttribute: ArticleTypeAttribute): string {
    return this.attributeValueResolverService.transform(value, articleTypeAttribute);
  }

}
